import remove from 'lodash/remove';
import omit from 'lodash/omit';
import { ExhibitorFeatures, FilterGroupProperties } from '../../common/Constants';
import Utils from '../Utils';

const removeGlobalFilterItems = (filterItems) => {
  remove(filterItems, { name: ExhibitorFeatures.New });
};

const mapFilterGroupResponse = (filterGroup) => {
  const staticItems = FilterGroupProperties[filterGroup.filterGroupName].staticFilterItems || [];
  const filterItems = filterGroup ? filterGroup.filterItems : [];
  removeGlobalFilterItems(filterItems);
  return {
    ...omit(filterGroup, 'filterItems'),
    items: filterItems,
    staticFilterItems: staticItems
  };
};

const trimItems = filterItems => (
  filterItems
    .map(item => ({ ...item, name: item.name.trim() }))
    .filter(item => item.name.length > 0)
);

const fetchItemName = (item, requestedLocale, primaryLocale) => {
  const itemForLocale = Utils.findByLocale(item.multilingual, requestedLocale);
  if (itemForLocale) {
    return itemForLocale.name;
  }
  const itemForPrimaryLocale = Utils.findByLocale(item.multilingual, primaryLocale);
  return itemForPrimaryLocale ? itemForPrimaryLocale.name : '';
};

const mapFromProductsAndServicesResponse = (response, requestedLocale, primaryLocale) => {
  const filterItems = response.productsAndServices.map(item => ({
    id: item.id,
    name: fetchItemName(item, requestedLocale, primaryLocale)
  }));
  return {
    filterGroupName: 'products_and_services',
    items: trimItems(filterItems)
  };
};

const requestModel = (filterGroup, locale) => ({
  filterGroupName: filterGroup.filterGroupName.trim(),
  locale,
  filterItems: trimItems(filterGroup.items)
});

const viewModel = (filterGroup, locale) => ({
  filterGroupName: filterGroup.filterGroupName,
  locale,
  items: trimItems(filterGroup.items)
});

export default {
  requestModel,
  viewModel,
  mapFilterGroupResponse,
  mapFromProductsAndServicesResponse
};
